import "./App.css";
import "./responsive.css";

import Container from "./components/layouts/Container";
import Presale from "./components/sections/Presale";
import Features from "./components/sections/Features";
import Roadmap from "./components/sections/Roadmap";
import Tokenomics from "./components/sections/Tokenomics";
import AboutEthraAI from "./components/sections/AboutEthraAI";
import Footer from "./components/layouts/Footer";
import Navbar from "./components/layouts/Navbar";

import PresaleLive from "./components/sections/PresaleLive";
import PresalePage from "./components/sections/PresalePage";

import { Routes, Route } from "react-router-dom";

import { createAppKit } from "@reown/appkit/react";
import { EthersAdapter } from "@reown/appkit-adapter-ethers";
import { base, bsc, mainnet, polygon } from "@reown/appkit/networks";
import { BASE_URL } from "./constant";

import { GoogleOAuthProvider } from "@react-oauth/google";
import { UserProvider } from "./components/providers/UserProvider";
import { PaymentTypeProvider } from "./components/providers/PaymentTypeProvider";
import { AuthenticateProvider } from "./components/providers/AuthenticateProvider";
import { TransactionProvider } from "./components/providers/TransactionProvider";
import { LanguageProvider } from "./components/providers/LanguageProvider";
import Translator from "./components/common/Translator";
import cacheProvider from "./utils/cacheProvider";

const projectId = "7b037fb00655ef362c37f963e74a16b8";

const networks = [bsc, mainnet, base, polygon];

const metadata = {
  name: "Ethra AI is an AI-powered trading ecosystem built on Ethereum.",
  description: "AI-POWERED TRADING. REAL REVENUE. REAL VALUE.",
  url: BASE_URL,
  icons: ["https://ethraai.com/logo.png"],
};

export const config = createAppKit({
  adapters: [new EthersAdapter()],
  networks,
  metadata,
  projectId,
  features: {
    analytics: true,
    email: false,
    socials: false,
    send: false,
  },
  enableNetworkSwitch: false,
});

const GOOGLE_API = process.env.REACT_APP_GOOGLE_API;

function HomePage() {
  return (
    <>
      <Presale />
      <Features />
      <Tokenomics />
      <AboutEthraAI />
      <Footer />
    </>
  );
}

function RoadmapPage() {
  return (
    <>
      <Roadmap />
    </>
  );
}

function PresalePageComponent() {
  return (
    <>
      <PresalePage />
      <Footer />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Translator
        from="en"
        to="en"
        googleApiKey={GOOGLE_API}
        cacheProvider={cacheProvider}
      >
        <GoogleOAuthProvider clientId="520725126595-uh0ldjfaiqbahhf0h86ujbceuh87akmr.apps.googleusercontent.com">
          <TransactionProvider>
            <UserProvider>
              <AuthenticateProvider>
                <PaymentTypeProvider>
                  <Container>
                    <Navbar />

                    <Routes>
                      <Route path="/" element={<HomePage />} />

                      <Route
                        path="/presale"
                        element={<PresalePageComponent />}
                      />

                      <Route
                        path="/roadmap"
                        element={<RoadmapPage />}
                      />
                    </Routes>
                  </Container>
                </PaymentTypeProvider>
              </AuthenticateProvider>
            </UserProvider>
          </TransactionProvider>
        </GoogleOAuthProvider>
      </Translator>
    </LanguageProvider>
  );
}

export default App;